import { createContext, useContext, useEffect, useState } from 'react';
import { useGetSubscriptionPlans } from '../api/subscriptionPlan.api';

const PlansContext = createContext(undefined);

export const PlansProvider = ({ children }) => {
  const [couponCode, setCouponCode] = useState(null);
  const [amountSaved,setAmountSaved] = useState("");
  const [plans, setPlans] = useState([]);

  const { data: fetchPlans, refetch } = useGetSubscriptionPlans(); 

  const refetchPlans = async () => {
    setPlans([]);
    const { data } = await refetch();
    if (data?.Response) {
      setPlans(data.Response);
    }
  };


  useEffect(() => {
    if (fetchPlans) {
      setPlans(fetchPlans.Response);
    }
  }, [fetchPlans]);

  useEffect(() => {
    if (couponCode && plans.length > 0) {
      const index = 2; 
      const twelveMonthPlan = plans.find(
        (plan) => plan.subscription_name?.trim() === "12 Months"
      );
      const mrp = Number(twelveMonthPlan?.mrp);
      const discount = Number(twelveMonthPlan?.discount);
      if (mrp && discount) {
        const discountAmount = Math.floor((mrp * discount) / 100);
        setAmountSaved(String(discountAmount));
      }
    }
  }, [couponCode, plans]);

  return (
    <PlansContext.Provider value={{ plans, setPlans, couponCode, setCouponCode, amountSaved, setAmountSaved, refetchPlans }}>
      {children}
    </PlansContext.Provider>
  );
};


export const usePlansProvider = () => {
  const context = useContext(PlansContext);
  if (!context) throw new Error("useGlobalContext must be used within GlobalProvider");
  return context;
};
